<template>
	<div>
		<div v-if="!moduleEnabled" class="mb-5">
			<vx-card>
				<vs-alert color="warning">
					<template slot="title">
						Module niet geactiveerd
					</template>
					De Voorraadpools module is nog niet geactiveerd. Activeer deze eerst in de
					<router-link to="/modules/voorraad/voorraadpools" style="color: inherit; text-decoration: underline;">module instellingen</router-link>
					.
				</vs-alert>
			</vx-card>
		</div>

		<div v-if="moduleEnabled">
			<vx-card title="Voorraad Pools" class="mb-5">
				<div class="w-full vx-row mb-5">
					<div class="vx-col sm:w-full md:w-1/2 w-1/2">
						<vs-input
							placeholder="Zoeken..."
							v-model="searchQuery"
							icon="search"
							@input="searchPools"
						></vs-input>
					</div>
					<div class="vx-col sm:w-full md:w-1/2 w-1/2 flex justify-end">
						<vs-button color="primary" type="filled" @click="openCreateDialog">
							<i class="fas fa-plus mr-2"></i> Nieuwe Pool
						</vs-button>
					</div>
				</div>

				<div v-if="pools.length === 0" class="text-center py-10">
					<p class="text-grey">Geen pools gevonden</p>
				</div>

				<table v-else class="w-full">
					<thead>
					<tr class="border-b-2">
						<th class="text-left p-4">Naam</th>
						<th class="text-left p-4">Beschrijving</th>
						<th class="text-center p-4">Acties</th>
					</tr>
					</thead>
					<tbody>
					<pool-row
						v-for="pool in pools"
						:key="pool.id"
						:pool="pool"
						@deleted="refreshPools"
					/>
					</tbody>
				</table>

				<div class="vx-row justify-center mt-5">
					<div class="vx-col">
						<vs-pagination :total="Math.ceil(totalPools / pageSize)" v-model="currentPage" @change="changePage"></vs-pagination>
					</div>
				</div>
			</vx-card>

			<create-pool
				:open="showCreateDialog"
				@close="closeCreateDialog"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import Create from './pools/create.vue';
import PoolRow from './pools/poolRow.vue';

export default {
	name: 'productsPools',
	components: {
		CreatePool: Create,
		PoolRow
	},
	data() {
		return {
			showCreateDialog: false,
			searchQuery: '',
			searchTimeout: null,
			currentPage: 1,
		}
	},
	computed: {
		...mapGetters({
			dashboardInitialized: 'dashboard/initialized',
			moduleEnabled: 'dashboard/moduleStockPoolsEnabled',
			pools: 'poolsData/pools',
			totalPools: 'poolsData/totalPools',
			pageSize: 'poolsData/pageSize',
			loading: 'poolsData/loading'
		})
	},
	methods: {
		refreshPools() {
			this.$store.dispatch('poolsData/getPools');
		},

		searchPools() {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.$store.dispatch('poolsData/setSearch', this.searchQuery);
			}, 300);
		},

		changePage() {
			this.$store.dispatch('poolsData/setPage', this.currentPage);
			this.refreshPools();
		},

		openCreateDialog() {
			this.showCreateDialog = true;
		},

		closeCreateDialog() {
			this.showCreateDialog = false;
			this.refreshPools();
		}
	},
	watch: {
		dashboardInitialized(newVal) {
			if (newVal && this.moduleEnabled) {
				this.refreshPools();
			}
		}
	},
	mounted() {
		if (this.dashboardInitialized && this.moduleEnabled) {
			this.refreshPools();
		}
	},
}
</script>

<style scoped>
.flex {
	display: flex;
}

.justify-end {
	justify-content: flex-end;
}

.justify-center {
	justify-content: center;
}

.mr-2 {
	margin-right: 0.5rem;
}

.border-b-2 {
	border-bottom: 2px solid #e5e7eb;
}

table {
	border-collapse: collapse;
	background: white;
}

table thead {
	background-color: #fafafa;
	font-weight: 600;
	font-size: 0.875rem;
}

table th {
	text-align: left;
	padding: 1rem;
	color: #6c757d;
}
</style>
